/** Utility function which displays defaults to
 * next 100 years, from the current year.
 * @param{startYear} Current year
 * @param{length} Length of years, will be displayed
*/
export const defaultYears = (startYear = new Date().getFullYear() + 99, length = 100) => Array.from({ length }).map((value, index) => startYear - index);
